import Container from './src/Container';

export default Container;
